import cookie from './cookie'
import storage from './storage'

export const getPublicAccountId = () => {
  return cookie.get('pubaccid')
}

export const isValidMustTypify = async () => {
  const currentDate = new Date()
  let targetDate = null
  await storage.get('mustNotTypify').then(date => {
    if (date) {
      targetDate = new Date(date)
    }
  })
  const isEmptyTargetDate = !targetDate
  const isAfterTargetDate = targetDate && currentDate > targetDate

  return isEmptyTargetDate || isAfterTargetDate
}
